import React, { FC, ReactNode, forwardRef, InputHTMLAttributes } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import {ru} from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import "./DateInputGradient.scss";
import TypedMessage from "../../atoms/TypedMessage/TypedMessage";

registerLocale("ru", ru);

interface DateInputGradientProps {
    className?: string;
    name: string;
    placeholder: string;
    ErrorMessage?: ReactNode;
    message?: string;
    value?: string;
    onChange?: (value: string) => void;
}

interface CustomInputProps
    extends Omit<InputHTMLAttributes<HTMLInputElement>, "name" | "placeholder" | "value" | "onChange"> {
    value?: string;
    name: string;
    placeholder: string;
    message?: string;
}

const pad2 = (v: number) => String(v).padStart(2, "0");

const toYmdLocal = (d: Date) =>
    `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

const fromYmdLocal = (s: string) => {
    const [y, m, d] = s.split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
};

const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
    ({ name, placeholder, value, message = "", ...rest }, ref) => {
        return (
            <div className="data-input-custom">
                <label>
                    <input
                        {...rest}
                        autoComplete="off"
                        ref={ref}
                        placeholder=" "
                        type="text"
                        name={name}
                        value={value || ""}
                        readOnly
                    />
                    <span className="data-input-custom__label">{placeholder}</span>
                    <div className={`data-input-custom__message ${message !== "" ? "active" : ""}`}>
                        {message !== "" && (
                            <TypedMessage
                                cursor={false}
                                loop={false}
                                className={"data-input-custom__message-text"}
                                strings={[message]}
                            />
                        )}
                    </div>
                </label>
            </div>
        );
    }
);

CustomInput.displayName = "CustomInput";

const DateInputGradient: FC<DateInputGradientProps> = ({
                                                           className = "",
                                                           name,
                                                           placeholder,
                                                           ErrorMessage,
                                                           message = "",
                                                           value,
                                                           onChange
                                                       }) => {
    const selectedDate = value ? fromYmdLocal(value) : null;

    return (
        <div className={`date-input-gradient ${className}`}>
            <div className={"date-input-gradient__label"}>{placeholder ? placeholder : "Дата"}</div>
            <DatePicker
                locale="ru"
                calendarStartDay={1}
                selected={selectedDate}
                onChange={(date: Date | null) => {
                    if (!onChange) return;
                    onChange(date ? toYmdLocal(date) : "");
                }}
                dateFormat="yyyy-MM-dd"
                customInput={<CustomInput name={name} placeholder={placeholder} message={message} />}
            />
            {ErrorMessage && <p style={{ color: "#DB3522", fontSize: "12px" }}>{ErrorMessage}</p>}
        </div>
    );
};

export default DateInputGradient;
